import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"560px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "sb-modal-title" }
const _hoisted_5 = { class: "sb-row" }
const _hoisted_6 = ["label"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["label"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "sb-goalrow" }
const _hoisted_13 = {
  key: 0,
  class: "sb-when"
}
const _hoisted_14 = {
  key: 1,
  class: "sb-history"
}
const _hoisted_15 = { class: "sb-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.metric ? 'Update Metric' : 'Add Metric'), 1),
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "sb-label" }, "Metric", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Name) = $event)),
        placeholder: "e.g. Quotes sent",
        ref: "nameInput"
      }, null, 512), [
        [_vModelText, _ctx.form.Name]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "sb-label" }, "Owner", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.OwnerEmployeeID) = $event))
          }, [
            _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "No owner", -1)),
            (_ctx.teamMembers.length)
              ? (_openBlock(), _createElementBlock("optgroup", {
                  key: 0,
                  label: _ctx.teamLabel(_ctx.form.Team)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (e) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: e.ID,
                      value: e.ID
                    }, _toDisplayString(e.Name), 9, _hoisted_7))
                  }), 128))
                ], 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("optgroup", {
              label: _ctx.teamMembers.length ? 'Everyone else' : 'Everyone'
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherEmployees, (e) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: e.ID,
                  value: e.ID
                }, _toDisplayString(e.Name), 9, _hoisted_9))
              }), 128))
            ], 8, _hoisted_8)
          ], 512), [
            [_vModelSelect, _ctx.form.OwnerEmployeeID]
          ])
        ]),
        (_ctx.teams.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "sb-label" }, "Team", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Team) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (t) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: t,
                    value: t
                  }, _toDisplayString(_ctx.teamLabel(t)), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.Team]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "sb-label" }, "Goal", -1)),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Cmp) = $event)),
          class: "sb-goal-cmp"
        }, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("option", { value: "gte" }, "At least", -1),
          _createElementVNode("option", { value: "lte" }, "At most", -1),
          _createElementVNode("option", { value: "eq" }, "Exactly", -1),
          _createElementVNode("option", { value: "range" }, "Between", -1)
        ]))], 512), [
          [_vModelSelect, _ctx.form.Cmp]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          step: "any",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Goal) = $event)),
          "aria-label": "Goal"
        }, null, 512), [
          [_vModelText, _ctx.form.Goal]
        ]),
        (_ctx.form.Cmp == 'range')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[20] || (_cache[20] = _createElementVNode("span", null, "and", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "any",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.GoalMax) = $event)),
                "aria-label": "Upper goal"
              }, null, 512), [
                [_vModelText, _ctx.form.GoalMax]
              ])
            ], 64))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Unit) = $event)),
          placeholder: "unit",
          "aria-label": "Unit",
          class: "sb-goal-unit"
        }, null, 512), [
          [_vModelText, _ctx.form.Unit]
        ])
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "sb-hint" }, "Unit is optional: $, $K, % or a word like min or days.", -1)),
      (_ctx.metric && _ctx.goalChanged)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "now",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.GoalWhen) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.form.GoalWhen]
              ]),
              _cache[21] || (_cache[21] = _createTextVNode(" New goal starts this week ", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "sb-hint" }, "(past weeks keep their old goal)", -1))
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "all",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.GoalWhen) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.form.GoalWhen]
              ]),
              _cache[23] || (_cache[23] = _createTextVNode(" The goal was wrong, fix every week", -1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.metric && _ctx.metric.Goals.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[24] || (_cache[24] = _createElementVNode("b", null, "Goal history", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metric.Goals, (g, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: g.FromWeek
              }, _toDisplayString(i == 0 ? 'First' : 'From ' + _ctx.weekLabel(g.FromWeek)) + ": " + _toDisplayString(_ctx.goalTextOf(g)), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "sb-label" }, "How it's counted", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Definition) = $event)),
        rows: "2",
        placeholder: "e.g. Quotes sent to dealers or customers, counted once per quote number."
      }, null, 512), [
        [_vModelText, _ctx.form.Definition]
      ]),
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "sb-hint" }, "If two people could count it differently, the definition isn't done yet.", -1)),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.metric)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "sb-remove",
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showConfirmDelete = true), ["prevent"]))
            }, "Remove Metric"))
          : _createCommentVNode("", true),
        _cache[25] || (_cache[25] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
        _createElementVNode("div", {
          class: "btn-light",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close')))
        }, "Cancel"),
        _createElementVNode("div", {
          class: _normalizeClass(["btn", _ctx.saving ? 'disable-button' : '']),
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.save()))
        }, _toDisplayString(_ctx.metric ? 'Save' : 'Add'), 3)
      ])
    ]),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.remove())),
          onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showConfirmDelete = false)),
          msg: "Remove this metric and all of its numbers?"
        }))
      : _createCommentVNode("", true)
  ]))
}